<template>
  <div>
    <v-toolbar color="primary" fixed dark app class="full-nav">
      <!-- <v-toolbar-title class="ml-0">
                  <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
        </v-toolbar-title>-->
      <v-toolbar-title class="ml-0">
        <span>&nbsp;&nbsp;&nbsp; {{ pageTitle }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn v-for="(item, index) in navItems" :key="index" flat :to="item.url">{{ item.title }}</v-btn>
      </v-toolbar-items>
      <v-menu offset-y origin="center center" :nudge-bottom="16" :nudge-right="12">
        <!-- <v-toolbar-title class="ml-3 title-report" slot="activator">
            <span>Báo cáo</span>
          </v-toolbar-title> -->
        <v-list class="pa-0">
          <v-list-tile ripple="ripple" rel="noopener" v-for="(item, index) in childItems" :key="index" :to="item.url">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>

      <all-applications />

      <v-menu offset-y origin="center center" :nudge-bottom="16" :nudge-right="12">
        <v-toolbar-title class="ml-0 logged-user" slot="activator">
          <span>
            <small>
              {{ loggedUser && loggedUser.Email }}
              <v-icon>expand_more</v-icon>
            </small>
          </span>
        </v-toolbar-title>
        <v-list class="pa-0">
          <v-list-tile @click="showLogs()" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>error</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logs trình duyệt</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile ripple="ripple" rel="noopener" to="/historylog">
            <v-list-tile-action>
              <v-icon>history</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Lịch sử hoạt động</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile ripple="ripple" rel="noopener" @click="$refs.testCallCenter.open()">
            <v-list-tile-action>
              <v-icon>check</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Test call center</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>fullscreen_exit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Đăng xuất</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- <v-btn color="primary" small @click="$refs.testCallCenter.open()">Test call center</v-btn> -->
        </v-list>
      </v-menu>
    </v-toolbar>

    <DialogTestCallCenter ref="testCallCenter" />
    <dialog-logs ref="dialogLogs" />
  </div>
</template>

<script>
import Util from '@/utils';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import menu from '@/api/menu';
import validate from '@/utils/validate';
import AllApplications from '@/components/AllApplications';
import DialogLogs from '@/components/DialogLogs';
import DialogTestCallCenter from '@/components/DialogTestCallCenter';

export default {
  name: 'app-toolbar',

  components: {
    AllApplications,
    DialogLogs,
    DialogTestCallCenter,
  },

  data: () => ({
    pageTitle: 'Vietmap Support',
    menuItems: [
      {
        icon: 'person',
        title: 'Phone',
        click: (e) => { },
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Đăng xuất',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        },
      },
    ],
    navItems: [
      {
        title: 'Tìm kiếm',
        url: '/search',
      },
      // {
      //   title: 'Kỹ thuật',
      //   url: '/supporter'
      // },
      {
        title: 'Giám sát',
        url: '/monitor',
      },
      {
        title: 'Điều phối',
        url: '/dispatch',
      },
      {
        title: 'Gửi tin nhắn',
        url: '/sendsms'
      },
      // {
      //   title: 'Gửi thông báo',
      //   url: '/sendnotify'
      // }
    ],
    childItems: [
      {
        title: 'Báo cáo',
        name: 'Báo cáo tăng ca',
        url: '/reporting/detail'
      },
      {
        title: 'Báo cáo',
        name: 'Báo cáo thời gian làm việc',
        url: '/reporting/worktime'
      }
    ],
    history: {
      title: 'Lịch sử hoạt động',
      url: '/historylog',
    },
    searchText: '',
    loading: false,
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    ...mapGetters(['loggedUser']),
  },
  watch: {
    $route (to, from) {
      let path = this.$route.path;
      let item = [...this.navItems, ...this.childItems, this.history].filter(
        (a) => a.url === path
      )[0];
      if (item) {
        this.pageTitle = item.title;
      }
    },
  },
  mounted () {
    this.menuItems[0].title = this.loggedUser ? this.loggedUser.phone : '';
  },
  methods: {
    ...mapActions(['getUserInfo', 'SeachCompanyRequest']),
    ...mapMutations(['SET_SEARCH_TEXT']),

    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },

    handleFullScreen () {
      Util.toggleFullScreen();
    },

    logout () {
      window.getApp.$emit('APP_LOGOUT');
    },

    search () {
      if (this.searchText) {
        let keywordRemovedVietnamese = validate.transferVietnamese(
          this.searchText
        );
        this.loading = true;
        this.SET_SEARCH_TEXT(keywordRemovedVietnamese);

        this.SeachCompanyRequest({ Key: keywordRemovedVietnamese })
          .catch((_) => {
            window.getApp.showMessage(
              'Có lỗi xảy ra, vui lòng thử lại sau',
              'error'
            );
          })
          .finally((_) => {
            this.loading = false;
          });
      }
    },

    showLogs () {
      this.$refs.dialogLogs.open();
    },
  },
};
</script>

<style lang="stylus" scoped>
  .full-nav {
    padding-left: 0 !important;
    z-index: 1000;
  }

  .hambuger-button {
    margin-left: -15px;
  }

  .search-field {
    margin-top: 8px !important;
    padding-left: 40px !important;
    padding-right: 20px !important;
  }

  .logged-user {
    margin-top: -5px !important;
    margin-left: 5px !important;
  }
  .title-report {
    font-size: 14px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue